import { DataTable } from "@/components/data-table";
import { Form } from "@/components/form";
import { formatNumber, formatString } from "@/shared/formats";
import { Stack, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { Articulo } from "@/shared/types/articulo";

interface ArticuloTransferenciaArticuloListProps {
    items: { articulo?: Articulo, articuloId: string, cantidad: number }[],
    remove?: (index: number) => void,
}

export default function ArticuloTransferenciaArticuloList({
    items,
    remove = () => { }
}: ArticuloTransferenciaArticuloListProps) {
    return <Stack gap={1} flex={1} minHeight={"350px"}>
        <Stack direction={"row"} alignItems={"center"}>
            <Typography variant="h6" flex={"1 1 auto"}>Artículos</Typography>
        </Stack>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={items}
                columns={[
                    { header: "#", render: (_, index) => formatNumber(index + 1), width: "auto" },
                    { header: "Nombre", render: row => formatString(row.articulo?.nombre) },
                    { header: "Cantidad (uds.)", render: row => formatNumber(row.cantidad), align: "right" },
                    {
                        header: "", render: (_, index) => <Form.IconButton size="small" onClick={() => remove(index)}>
                            <ClearIcon fontSize="small" />
                        </Form.IconButton>, width: "auto", align: "center"
                    }
                ]}
            />
        </DataTable>
    </Stack>
}